import React from "react"
import { withFieldLabelAndHint } from "./field"
import { FormElement } from "./form"

type Props = {
  id?: string
  children: React.ReactNode
} & FormElement

const ComposedFormField = ({ id, children }: Props) => {
  return (
    <div className="cobalt-ComposedFormField">
      {React.Children.toArray(children).map((child, index) => {
        return index === 0
          ? React.cloneElement(child as React.ComponentElement<any, any>, {
              id,
            })
          : child
      })}
    </div>
  )
}

const wrappedComponent = withFieldLabelAndHint(ComposedFormField)
wrappedComponent.displayName = "ComposedField"

export { wrappedComponent as ComposedField }
